"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var offscreenCanvasPonyfill_1 = require("../util/offscreenCanvasPonyfill");
function PrerenderedCanvas(props) {
  var width = props.width,
    height = props.height,
    _props$highResolution = props.highResolutionScaling,
    highResolutionScaling = _props$highResolution === void 0 ? 1 : _props$highResolution,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    imageData = props.imageData,
    blockKey = props.blockKey,
    showSoftClip = props.showSoftClip;
  var _ref = (0, react_1.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    done = _ref2[0],
    setDone = _ref2[1];
  var featureCanvas = (0, react_1.useRef)(null);
  (0, react_1.useEffect)(function () {
    if (!imageData) {
      return;
    }
    var canvas = featureCanvas.current;
    if (!canvas) {
      return;
    }
    var context = canvas.getContext('2d');
    if (!context) {
      return;
    }
    (0, offscreenCanvasPonyfill_1.drawImageOntoCanvasContext)(imageData, context);
    setDone(true);
  }, [imageData]);
  var softClipString = showSoftClip ? '_softclipped' : '';
  var blockKeyStr = blockKey ? '_' + blockKey : '';
  var testId = "prerendered_canvas".concat(softClipString).concat(blockKeyStr).concat(done ? '_done' : '');
  return react_1.default.createElement("canvas", {
    "data-testid": testId,
    ref: featureCanvas,
    width: width * highResolutionScaling,
    height: height * highResolutionScaling,
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  });
}
exports.default = PrerenderedCanvas;